module.exports = {
  mode: 'jit',
  purge: [
    './pages/**/*.{js,ts,jsx,tsx}',
    './components/**/*.{js,ts,jsx,tsx}',
    './stories/**/*.mdx',
  ],
  darkMode: false, // or 'media' or 'class'
  theme: {
    screens: {
      mobile: '375px',
      tablet: '768px',
      desktop: '1440px',
    },
    colors: {
      transparent: 'transparent',
      oxfordBlue: '#0F1C39',
      blue: '#1199FA',
      skyBlue: '#93D2FD',
      white: '#FFFFFF',
      navy: '#1E3F6F',
      green: '#20BCA4',
      orange: '#F76341',
      yellow: '#FFBF00',
      red: '#E64B60',
      black: '#000000',
      darkGray: '#212529',
      gray: '#626973',
      lightGray: '#B0B4B9',
      dark: '#0B1426',
      light: '#F7F9FA',
      white10: 'rgba(255, 255, 255, 0.1)',
      white20: 'rgba(255, 255, 255, 0.2)',
      black30: 'rgba(0, 0, 0, 0.3)',
      modalBackground: 'rgba(11, 20, 38, 0.6)',
      transferTransactionSummaryBackground: 'rgba(255, 255, 255, 0.1)',
      historyStatusCompletedBackground: 'rgba(32, 188, 164, 0.2)',
      historyStatusCancelledBackground: 'rgba(176, 180, 185, 0.3)',
      historyStatusPendingBackground: 'rgba(255, 191, 0, 0.2)',
      historyStatusFailedBackground: 'rgba(230, 75, 96, 0.2)',
      betaBadge: 'rgba(30, 63, 111, 0.5)',
      blockBackground: 'rgba(0, 0, 0, 0.3)',
      card: 'rgba(0, 0, 0, 0.3)',
    },
    fontSize: {
      heading1: ['50px', { lineHeight: '60px' }],
      heading2: ['40px', { lineHeight: '52px' }],
      heading3: ['29px', { lineHeight: '35px' }],
      heading4: ['20px', { lineHeight: '26px' }],
      heading5: ['18px', { lineHeight: '26px' }],
      heading6: ['16px', { lineHeight: '22px' }],
      body: ['16px', { lineHeight: '22px' }],
      smallSemibold: ['14px', { lineHeight: '22px' }],
      smallMedium: ['14px', { lineHeight: '17px' }],
      smallRegular: ['14px', { lineHeight: '21px' }],
      number: ['24px', { lineHeight: '22px' }],
      microLight: ['12px', { lineHeight: '14px' }],
      micro: ['12px', { lineHeight: '22px' }],
      iconSmall: ['20px', { lineHeight: '1em' }],
      iconMedium: ['24px', { lineHeight: '1em' }],
      iconLarge: ['30px', { lineHeight: '1em' }],
      iconXLarge: ['40px', { lineHeight: '1em' }],
    },
    spacing: {
      0: '0px',
      0.5: '4px',
      1: '8px',
      1.5: '12px',
      2: '16px',
      2.5: '20px',
      3: '24px',
      4: '32px',
      5: '40px',
      6: '48px',
      7: '56px',
      8: '64px',
      9: '72px',
      base: '80px',
    },
    extend: {
      inset: {
        0: 0,
      },
      zIndex: {
        popup: 99,
        dropdown: 98,
        '-1': '-1',
      },
      maxWidth: {
        default: '510px',
        large: '1172px',
      },
      width: {
        logoButtonWidth: '330px',
      },
      height: {
        logoButtonHeight: '60px',
        progressBarTrackHeight: '2px',
        progressBarHeight: '44.48px',
        navBarLogoHeight: '27px',
      },
      boxShadow: {
        default: '0px 0px 10px rgba(255, 255, 255, 0.2)',
        card: '0px 4px 40px rgba(0, 0, 0, 0.1)',
      },
      borderRadius: {
        small: '4px',
        medium: '8px',
        large: '15px',
      },
      keyframes: {
        spin: {
          from: { transform: 'rotate(360deg)' },
          to: { transform: 'rotate(0deg)' },
        },
        'bg-bounce': {
          '0%,100%': { transform: 'translateY(20px)' },
          '50%': { transform: 'translateY(-20px)' },
        },
        'bg-bounce-fast': {
          '0%,100%': { transform: 'translateY(20px)' },
          '50%': { transform: 'translateY(-55px)' },
        },
      },
      animation: {
        'spin-ease-in-out': 'spin 1.5s ease-in-out infinite',
        'bg-bounce': 'bg-bounce 8s ease-in-out infinite',
        'bg-bounce-fast': 'bg-bounce-fast 8s ease-in-out infinite',
      },
    },
  },
  variants: {
    extend: {},
  },
  plugins: [require('@graxmonzo/tailwind-caret-color')],
};
